import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

import CustomMuiLink from 'common/components/custom-mui-link/CustomMuiLink';

const DropdownMenuItem: React.FC<IDropdownMenuItemProps> = ({
  route,
  handleClose,
  label,
  target,
}) => {
  return (
    <CustomMuiLink target={target} href={route}>
      <MenuItem onClick={handleClose}>{label}</MenuItem>
    </CustomMuiLink>
  );
};

export default DropdownMenuItem;
